import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Barcode({ ...props }: IconProps): JSX.Element {
  return <Barcode.Solid {...props} />;
}

Barcode.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 5.25C4.41421 5.25 4.75 5.58579 4.75 6V19C4.75 19.4142 4.41421 19.75 4 19.75C3.58579 19.75 3.25 19.4142 3.25 19V6C3.25 5.58579 3.58579 5.25 4 5.25ZM8 5.25C8.41421 5.25 8.75 5.58579 8.75 6V13.8C8.75 14.2142 8.41421 14.55 8 14.55C7.58579 14.55 7.25 14.2142 7.25 13.8V6C7.25 5.58579 7.58579 5.25 8 5.25ZM12 5.25C12.4142 5.25 12.75 5.58579 12.75 6V19C12.75 19.4142 12.4142 19.75 12 19.75C11.5858 19.75 11.25 19.4142 11.25 19V6C11.25 5.58579 11.5858 5.25 12 5.25ZM16 5.25C16.4142 5.25 16.75 5.58579 16.75 6V7.3C16.75 7.71421 16.4142 8.05 16 8.05C15.5858 8.05 15.25 7.71421 15.25 7.3V6C15.25 5.58579 15.5858 5.25 16 5.25ZM20 5.25C20.4142 5.25 20.75 5.58579 20.75 6V19C20.75 19.4142 20.4142 19.75 20 19.75C19.5858 19.75 19.25 19.4142 19.25 19V6C19.25 5.58579 19.5858 5.25 20 5.25ZM16 10.45C16.4142 10.45 16.75 10.7858 16.75 11.2V19C16.75 19.4142 16.4142 19.75 16 19.75C15.5858 19.75 15.25 19.4142 15.25 19V11.2C15.25 10.7858 15.5858 10.45 16 10.45ZM8 16.95C8.41421 16.95 8.75 17.2858 8.75 17.7V19C8.75 19.4142 8.41421 19.75 8 19.75C7.58579 19.75 7.25 19.4142 7.25 19V17.7C7.25 17.2858 7.58579 16.95 8 16.95Z"
        fill="currentColor"
      />
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
